<template>
    <v-app id="inspire">
        <Header type="search" />
        <v-main class="grey lighten-3">
            <v-container>
                <v-row>
                    <Menu />
                    <v-container class="col-10">
                        <v-row>
                            <v-col class="page-top d-flex justify-space-between" cols="12">
                                <div>
                                    <div class="page-title">Расписание</div>
                                    <div class="breadcrumb">Расписание</div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-container class="col-10">
                            <Grid :column="1" :gap="20">
                                <Block :padding="20">
                                    <div class="tabs">
                                        <v-tabs centered id="horizontal_tabs" v-model="schedule_tab"
                                            class="d-flex align-center schedule__tab">
                                            <v-tab v-for="item in schedules" :key="item.tab">
                                                {{ item.tab }}
                                            </v-tab>
                                        </v-tabs>
                                        <transition name="fade">
                                            <v-btn-toggle v-if="schedule_tab == 1" v-model="toggle_category" mandatory
                                                class="ml-5 rounded-lg">
                                                <v-btn>
                                                    Сотрудники
                                                </v-btn>
                                                <v-btn>
                                                    Помещение
                                                </v-btn>
                                            </v-btn-toggle>
                                        </transition>
                                    </div>
                                </Block>
                                <Block :padding="0" :overflowHidden="true">
                                    <div class="filter">
                                        <div class="top-line">
                                            <div class="button-line">
                                                <Grid :column="4" :gap="20"
                                                    :customStyle="{ gridTemplateColumns: schedule_tab != 1 ? '149px 76px 180px 233px' : '180px 233px 1fr 1fr' }">
                                                    <v-btn-toggle v-model="calendarType" mandatory v-if="schedule_tab != 1">
                                                        <v-btn>
                                                            День
                                                        </v-btn>
                                                        <v-btn>
                                                            Неделя
                                                        </v-btn>
                                                    </v-btn-toggle>
                                                    <v-btn-toggle v-if="schedule_tab != 1">
                                                        <v-btn @click="changeDate('prev')"
                                                            style="padding: 0 !important; min-width: 38px !important;">
                                                            <v-icon>
                                                                mdi-chevron-left
                                                            </v-icon>
                                                        </v-btn>
                                                        <v-btn @click="changeDate('next')"
                                                            style="padding: 0 !important; min-width: 38px !important;">
                                                            <v-icon>
                                                                mdi-chevron-right
                                                            </v-icon>
                                                        </v-btn>
                                                    </v-btn-toggle>
                                                    <VueDatePicker no-title no-header color="#629f34" v-model="date"
                                                        :disabled="calendarType == 1">
                                                        <template #activator>
                                                            <button class="button custom__date-button" ref="activator"
                                                                type="button">
                                                                <v-icon dark small class="mr-2">
                                                                    mdi-calendar-blank-outline
                                                                </v-icon> {{ dpRangeLabel }}
                                                            </button>
                                                        </template>
                                                    </VueDatePicker>
                                                    <v-btn-toggle v-model="dayPeriod" mandatory>
                                                        <v-btn>
                                                            Утро
                                                        </v-btn>
                                                        <v-btn>
                                                            Вечер
                                                        </v-btn>
                                                        <v-btn>
                                                            Весь день
                                                        </v-btn>
                                                    </v-btn-toggle>
                                                </Grid>
                                            </div>
                                            <v-btn class="filter-btn" @click="showFilterGrid = !showFilterGrid">
                                                <Icon :iconName="showFilterGrid ? 'x' : 'filter'" width=" 16" height="16"
                                                    viewBox="0 0 16 16" strockeWidth="2" stroke="#fff" />
                                                Фильтр
                                            </v-btn>
                                        </div>
                                        <transition name="fade">
                                            <div class="hidden-block" v-if="showFilterGrid">
                                                <Grid :column="4" :gap="20" :customStyle="{ rowGap: 0 }">
                                                    <div class="filter__field">
                                                        <span class="label">
                                                            Сотрудники
                                                        </span>
                                                        <v-select class="rounded-lg custom__select"
                                                            v-model="groupLessonFilter.specialist_id" :items="events"
                                                            item-value="specialist_id" item-text="category"
                                                            ref="selectedEl1"
                                                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                                            placeholder="Выбрать" append-icon="mdi-chevron-down" outlined
                                                            dense color="#629F33" style="height: 40px"></v-select>
                                                    </div>
                                                    <div class="filter__field">
                                                        <span class="label">
                                                            Должность
                                                        </span>
                                                        <v-select class="rounded-lg custom__select"
                                                            v-model="groupLessonFilter.post_id" :items="events"
                                                            item-value="post_id" item-text="post_name" ref="selectedEl3"
                                                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                                            placeholder="Выбрать" append-icon="mdi-chevron-down" outlined
                                                            dense color="#629F33"
                                                            style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"></v-select>
                                                    </div>
                                                    <div class="filter__field">
                                                        <span class="label">
                                                            Помещение
                                                        </span>
                                                        <v-select class="rounded-lg custom__select"
                                                            v-model="groupLessonFilter.room_id" :items="events"
                                                            item-value="room_id" item-text="room_name" ref="selectedEl4"
                                                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                                            placeholder="Выбрать" append-icon="mdi-chevron-down" outlined
                                                            dense color="#629F33"
                                                            style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"></v-select>
                                                    </div>
                                                    <div class="filter__field">
                                                        <span class="label">
                                                            Клиент
                                                        </span>
                                                        <v-autocomplete class="rounded-lg custom__select"
                                                            :items="listClient ? listClient.client : []"
                                                            item-value="client_id" item-text="name"
                                                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                                            placeholder="Выбрать" append-icon="mdi-chevron-down"
                                                            no-data-text="Результатов не найдено"
                                                            :search-input.sync="groupLessonFilter.search_client"
                                                            v-model="groupLessonFilter.select_client" outlined dense
                                                            color="#629F33">
                                                        </v-autocomplete>
                                                    </div>
                                                    <div class="filter__field">
                                                        <span class="label">
                                                            Услуга
                                                        </span>
                                                        <v-select class="rounded-lg custom__select"
                                                            v-model="groupLessonFilter.service_id" :items="events"
                                                            ref="selectedEl6" item-text="name" item-value="service_id"
                                                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                                            placeholder="Выбрать" append-icon="mdi-chevron-down" outlined
                                                            dense color="#629F33"></v-select>
                                                    </div>
                                                    <div class="filter__field">
                                                        <span class="label">
                                                            Статус
                                                        </span>
                                                        <v-select class="rounded-lg custom__select"
                                                            v-model="groupLessonFilter.status" :items="statusTypes"
                                                            ref="selectedEl2" item-text="type_name" item-value="type_id"
                                                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                                            placeholder="Выбрать" append-icon="mdi-chevron-down" outlined
                                                            dense color="#629F33"></v-select>
                                                    </div>
                                                    <div class="filter__field colspan-4 button-block">
                                                        <v-btn class="apply" @click="filterEvents()"
                                                            :disabled="buttonDisabled">
                                                            Применить
                                                        </v-btn>
                                                        <transition name="fade">
                                                            <v-btn class="clear" @click="clearFilter()"
                                                                v-if="!buttonDisabled">
                                                                Очистить
                                                            </v-btn>
                                                        </transition>
                                                    </div>

                                                </Grid>
                                            </div>
                                        </transition>
                                    </div>
                                    <Calendar :events="events" :header="calendarHeader" :calendarTime="calendarTime"
                                        :headerType="schedule_tab" :itemBySort="itemBySort" />
                                </Block>
                            </Grid>
                        </v-container>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>
<script>
import { scheduleActionTypes } from "@/store/modules/schedule";
import { globalMethods } from "@/mixins/globalMethods";
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import Calendar from '@/components/Calendar.vue';
import { mapState } from "vuex";
import { VueDatePicker } from "@mathieustan/vue-datepicker";
import { clientActionTypes } from '@/store/modules/client';
export default {
    name: 'Schedule2',
    mixins: [globalMethods],
    components: {
        Header,
        Menu,
        VueDatePicker,
        Calendar
    },
    mounted() {
        this.getEvents()
    },
    computed: {
        ...mapState({
            isLoading: state => state.schedule.isLoading,
            listClient: state => state.client.listClient,
            schedule: state => state.schedule.data,
            validationErrors: state => state.schedule.validationErrors,
        }),
        buttonDisabled() {
            let hasFilter = Object.entries(this.groupLessonFilter).filter(([key, value]) => !!value)
            return hasFilter.length > 0 ? false : true
        },
        dpRangeLabel: function () {
            let str = ''
            if (this.calendarType == 1) {
                if (
                    this.$moment(this.start).format('DD') == this.$moment(this.end).format('DD')
                ) {
                    str = this.$moment(this.start).format('DD')
                } else {
                    str = this.$moment(this.start).format('DD') + '-' + this.$moment(this.end).format('DD')
                }
                if (
                    this.$moment(this.start).format('MM') == this.$moment(this.end).format('MM')
                ) {
                    str += ' ' + this.$moment(this.start).format('MMMM')
                } else {
                    str += ' ' + this.$moment(this.start).format('MMMM') + '-' + this.$moment(this.end).format('MMMM')
                }
            } else {
                str = this.$moment(this.start).format('DD MMMM YYYY')
            }
            return str
        }
    },
    data() {
        return {
            statusTypes: [
                { type_id: 0, type_name: 'Запланировано' },
                { type_id: 1, type_name: 'Выполнено' },
                { type_id: 2, type_name: 'Отменено' },
            ],
            groupLessonFilter: {
                specialist_id: null,
                post_id: null,
                room_id: null,
                search_client: '',
                select_client: null,
                service_id: null,
                status: null,
            },
            date: null,
            toggle_category: 0,
            start: this.$moment().weekday(0).toDate(),
            end: this.$moment().weekday(6).toDate(),
            select: null,
            showFilterGrid: false,
            rows: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            schedules: [
                { tab: 'Групповые занятия' },
                { tab: 'Индивидуальные занятия' },
                { tab: 'Все' },
            ],
            schedule_tab: 0,
            calendarType: 1,
            dayPeriod: 2,
            events: [],
            calendarHeader: [],
            calendarTime: [
                '04:00',
                '05:00',
                '06:00',
                '07:00',
                '08:00',
                '09:00',
                '10:00',
                '11:00',
                '12:00',
                '13:00',
                '14:00',
                '15:00',
                '16:00',
                '17:00',
                '18:00',
                '19:00',
                '20:00',
                '21:00',
            ],
            itemBySort: 'specialist_name',
            weekDayName: {
                1: 'ПН',
                2: 'ВТ',
                3: 'СР',
                4: 'ЧТ',
                5: 'ПТ',
                6: 'СБ',
                7: 'ВС',
            }
        }
    },
    watch: {
        'groupLessonFilter.search_client': function (value) {
            if (value !== '') {
                value = value.trim()
                this.$store.dispatch(clientActionTypes.searchClient, {
                    client_field: value
                })
                return value
            }
        },
        date: function (value) {
            if (value) {
                this.$set(this, 'start', this.$moment(value, 'YYYY-MM-DD').toDate())
                this.$set(this, 'date', null)
            }
        },
        toggle_category: function (value) {
            if (value == 0) {
                this.$set(this, 'itemBySort', 'specialist_name')
            } else if (value == 1) {
                this.$set(this, 'itemBySort', 'room_name')
            }
            this.changeCalendarHeader()
        },
        start: function (value) {
            this.getEvents()
        },
        schedule_tab: function (value) {
            let whatGet = ''
            if (value == 0) {
                whatGet = 'group'
                this.$set(this, 'events', this.schedule?.schedule?.group)
            } else if (value == 1) {
                whatGet = 'indiv'
                this.$set(this, 'start', this.$moment().toDate())
                this.$set(this, 'calendarType', 0)
            } else if (value == 2) {
                whatGet = 'all'
                this.$set(this, 'events', this.schedule?.schedule?.all)
            }

        },
        dayPeriod: function (value) {
            let newCalendarTime = []
            if (value == 0) {
                for (let i = 1; i <= 10; i++) {
                    newCalendarTime.push(this.$moment('03:00', 'HH:mm').add(`+${i}`, 'hour').format('HH:mm'))
                }
            } else if (value == 1) {
                for (let i = 1; i <= 8; i++) {
                    newCalendarTime.push(this.$moment('13:00', 'HH:mm').add(`+${i}`, 'hour').format('HH:mm'))
                }
            } else if (value == 2) {
                for (let i = 1; i <= 18; i++) {
                    newCalendarTime.push(this.$moment('03:00', 'HH:mm').add(`+${i}`, 'hour').format('HH:mm'))
                }
            }
            this.$set(this, 'calendarTime', newCalendarTime)
        },
        calendarType: function (value) {
            if (value == 0) {
                this.$set(this, 'start', this.$moment().toDate())
            } else {
                this.getEvents()
            }
        }
    },
    methods: {
        filterEvents() {
            let newEvents = Object.entries(this.groupLessonFilter).reduce((result, [key, value]) => {
                if (value !== null) {
                    if (key == 'select_client') {
                        let filterData = this.events.filter((item) => {
                            for (let client of item.client_list) {
                                return client.client_id === value
                            }
                        })
                        return [...result, ...filterData];
                    } else {
                        let filterData = this.events.filter((item) => item[key] === value);
                        return [...result, ...filterData];
                    }
                } else {
                    return result
                }
            }, [])

            this.$set(this, 'events', newEvents)
        },
        clearFilter() {
            let whatGet = ''
            if (this.schedule_tab == 0) {
                whatGet = 'group'
            } else if (this.schedule_tab == 1) {
                whatGet = 'indiv'
            } else if (this.schedule_tab == 2) {
                whatGet = 'all'
            }
            this.$set(this, 'events', this.schedule.schedule?.[whatGet])
            this.$set(this, 'groupLessonFilter', {
                specialist_id: null,
                post_id: null,
                room_id: null,
                search_client: '',
                select_client: null,
                service_id: null,
                status: null,
            })
        },
        changeCalendarHeader() {
            let newCalendarHeader = this.schedule?.schedule?.indiv.reduce((result, event) => {
                return result.includes(event[this.itemBySort]) ? result : [...result, event[this.itemBySort]]
            }, [])
            this.$set(this, 'calendarHeader', newCalendarHeader)

        },
        getEvents() {
            let obj = {}
            if (this.calendarType == 1) {
                obj = {
                    start_date: this.$moment(this.start).format('YYYY-MM-DD'),
                    end_date: this.$moment(this.end).format('YYYY-MM-DD')
                }
                this.$set(this, 'calendarHeader', Object.values(this.weekDayName))
            } else {
                obj = {
                    start_date: this.$moment(this.start).format('YYYY-MM-DD'),
                    end_date: this.$moment(this.start).format('YYYY-MM-DD')
                }
                this.$set(this, 'calendarHeader', [this.weekDayName[this.$moment(this.start).day()]])
            }
            this.$store.dispatch(scheduleActionTypes.getSchedule, obj).then((response) => {
                let whatGet = ''
                if (this.schedule_tab == 0) {
                    whatGet = 'group'
                } else if (this.schedule_tab == 1) {
                    whatGet = 'indiv'
                    let newCalendarHeader = this.schedule?.schedule?.[whatGet].reduce((result, event) => {
                        return result.includes(event[this.itemBySort]) ? result : [...result, event[this.itemBySort]]
                    }, [])
                    this.$set(this, 'calendarHeader', newCalendarHeader)

                } else if (this.schedule_tab == 2) {
                    whatGet = 'all'
                }
                this.$set(this, 'events', response.schedule?.[whatGet])
            })
        },
        changeDate(type) {
            this.$set(this, 'events', [])
            let newStart, newEnd
            if (type == 'next') {
                if (this.calendarType == 0) {
                    newStart = this.$moment(this.start).add(+1, 'day').toDate()
                } else {
                    newStart = this.$moment(this.start).add(+1, 'week').weekday(0).toDate()
                    newEnd = this.$moment(this.start).add(+1, 'week').weekday(6).toDate()
                }

            } else if (type == 'prev') {
                if (this.calendarType == 0) {
                    newStart = this.$moment(this.start).add(-1, 'day').toDate()
                } else {
                    newStart = this.$moment(this.start).add(-1, 'week').weekday(0).toDate()
                    newEnd = this.$moment(this.start).add(-1, 'week').weekday(6).toDate()
                }
            }
            if (this.calendarType == 0) {
                this.$set(this, 'start', newStart)
            } else {
                this.$set(this, 'start', newStart)
                this.$set(this, 'end', newEnd)
            }
            this.getEvents()
        }
    }
}
</script>
<style scoped lang="scss">
.v-btn-toggle {
    button {
        font-family: 'Circe';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        text-transform: none;
        background: #fff !important;

        &::before {
            display: none;
        }

        &:first-child {
            border-radius: 12px 0 0 12px !important;
        }

        &:last-child {
            border-radius: 0 12px 12px 0 !important;
        }
    }
}

.tabs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;

    .v-btn-toggle {
        right: 0;
    }

    .theme--light.v-tabs>.v-tabs-bar {
        max-height: 40px;
    }
}

.custom__date-button {
    max-width: 100%;
    box-sizing: border-box;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 !important;
}

.custom__select.v-select--is-menu-active {
    outline: 4px solid #E0ECD6;
}
</style>